import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { InvoiceLiteralsFacadeService } from 'src/app/shared/services/literals/invoices.literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { InvoicesFacadeService } from './invoices.facade.service';

@Injectable({ providedIn: 'root' })
export class InvoicesSearchService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private paginatorService: PaginatorFacadeService,
    private invoicesLiterals: InvoiceLiteralsFacadeService,
    private invoicesFacade: InvoicesFacadeService,
  ) {}

  invoicesSearch(): Observable<QcResponseGrid> {
    const url =
      this.environmentFacadeService.getEnvironment() +
      `/rest/v1/invoices/findByFilter?start=${
        this.paginatorService.pageIndex * this.paginatorService.itemsNumber
      }&pageSize=${this.paginatorService.itemsNumber}&sortField=${
        this.paginatorService.selectedSortField === this.invoicesLiterals.invoiceDate
          ? 'INVOICE_DATE'
          : this.paginatorService.selectedSortField === this.invoicesLiterals.grandTotal
            ? 'GRAND_TOTAL'
            : null
      }&sortOrder=${this.paginatorService.selectedOrder === this.invoicesLiterals.ascending ? 'ASC' : 'DESC'}`;

    const body = {
      deleted: false,
      invoiceDateFrom: this.invoicesFacade.dateFromFormat,
      invoiceDateUntil: this.invoicesFacade.dateUntilFormat,
      invoiceNumber: this.invoicesFacade.invoiceNumber,
      loyaltyCard: this.invoicesFacade.loyaltyCard,
      storeId: this.invoicesFacade.Store,
    };

    return this.http.post<QcResponseGrid>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }
}
